import { qs, qsAll } from "../dom-helpers";

class Modals {
  constructor() {
    if (!qs(".modal")) return;

    this.openModalButton = qsAll(".button--modal");
    this.closeButtons = qsAll(".close");
    this.overlay = qs(".overlay");
    this.modal = qs(".modal");
    this.main = qs("#main");
    this._run();
  }

  _run() {
    try {
      this._registerEventListeners();
    } catch (e) {
      console.error(e); // eslint-disable-line
    }
  }

  _registerEventListeners() {
    if (this.openModalButton) {
      this.openModalButton.forEach((openButton) => {
        openButton.addEventListener("click", () =>
          this._handleOpenContactModal(openButton)
        );
      });
    }

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => this._handleCloseModal());
    });

    document.addEventListener("click", (e) => {
      const target = e.target;
      if (target.classList.contains("modal")) {
        this._handleCloseModal();
      }
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this._handleCloseModal();
      }
    });
  }

  _handleOpenContactModal(openButton) {
    this.overlay.classList.add("is-visible");
    this.modal.classList.add("is-visible");
    this.main.dataset.form_name = openButton.dataset.form_name;
  }

  _handleOpenSubscribeModal() {
    this.overlay.classList.add("is-visible");
    this.modal.classList.add("is-visible");
  }

  _handleCloseModal() {
    this.overlay.classList.remove("is-visible");
    this.modal.classList.remove("is-visible");
  }
}

export default Modals;
